import { NgModule, ModuleWithProviders, InjectionToken, Inject } from '@angular/core';
import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { GSP } from '@farris/ide-devkit';
import { CommonStructureService } from './service/common-structure-service';

export function factory(http: HttpClient, url: string) {
    return new CommonStructureService(http, url);
}

@NgModule({
    exports: [],
    providers: []
})

export class CommonStructureServiceModule {
    static forRoot(url: string): ModuleWithProviders {
        return {
            ngModule: CommonStructureServiceModule,
            providers: [
                { provide: 'url', useValue: url },
                { provide: CommonStructureService, useFactory: factory, deps: [HttpClient, 'url'] }
            ]
        };
    }
}

declare global {
    var gsp: GSP;
}

const globalGsp = (window.top as any).gsp;
(window as any).gsp = /*(globalGsp && globalGsp.createChild()) ||*/ new GSP(globalGsp);
